import HttpService from '@/common/HttpService';
import { InvoiceInfo, InvoiceByHandParams, ProjectInfoResult, InvoiceSimpleInfoResult, InvoiceDetailResult, ProjectType, SubmitInvoiceByHandParams, InvoiceDetailInfoResult } from './statement';

const systemId = 'ZHZJ'

export default class SmartMoneyService {

  /**
   * 通过扫码获取发票详情
   * @param qrText 二维码文本
   */
  static async getInvoiceInfoByQr (qrText: string) {
    return HttpService.getData<InvoiceInfo>({
      id: 'GetInvoiceInfoByQr',
      pageAddress: {pageMode:0,pageId:"Main",moduleId:"AppInterface",systemId},
      params: {qrText}
    })
    // await sleep(1200)
    // return {"invoiceTypeName":"湖南增值税普通发票","totalAmount":"562.14","totalTaxNum":"16.86","totalTaxSum":"579.00","invoiceDataCode":"4300174320","invoiceNumber":"10283592","billingTime":"2018-05-15","checkCode":"04564180895391466033","taxpayerName":"武汉源钉云互联科技有限公司","taxpayerNumber":"91420100MA4KYDQL0U","taxpayerAddress":"","taxpayerPhone":"","taxpayerBankName":"","taxpayerBankAccount":"","salesName":"衡阳市船山宾馆有限公司","salesNum":"91430400734740323B","salesAddress":"衡阳市石鼓区蒸湘北路30号","salesPhone":"8190188","salesBankName":"中国工商银行湖南衡阳瓦子坪支行","salesBankAccount":"1905023209022303895","details":[{"name":"*住宿服务*住宿费","sum":"562.14","taxRate":"3%","tax":"16.86"}]}
  }

  /**
   * 通过手动输入相应数据获取发票详情
   * @param params 参数
   */
  static async getInvoiceInfoByHand (params: InvoiceByHandParams) {
    return HttpService.getData<InvoiceInfo>({
      id: 'GetInvoiceInfoByHand',
      pageAddress: {pageMode:0,pageId:"Main",moduleId:"AppInterface",systemId},
      params: params
    })
    // await sleep(1200)
    // return {"invoiceTypeName":"湖南增值税普通发票","totalAmount":"562.14","totalTaxNum":"16.86","totalTaxSum":"579.00","invoiceDataCode":"4300174320","invoiceNumber":"10283592","billingTime":"2018-05-15","checkCode":"04564180895391466033","taxpayerName":"武汉源钉云互联科技有限公司","taxpayerNumber":"91420100MA4KYDQL0U","taxpayerAddress":"","taxpayerPhone":"","taxpayerBankName":"","taxpayerBankAccount":"","salesName":"衡阳市船山宾馆有限公司","salesNum":"91430400734740323B","salesAddress":"衡阳市石鼓区蒸湘北路30号","salesPhone":"8190188","salesBankName":"中国工商银行湖南衡阳瓦子坪支行","salesBankAccount":"1905023209022303895","details":[{"name":"*住宿服务*住宿费","sum":"562.14","taxRate":"3%","tax":"16.86"}]}
  }

  /**
   * 通过ID获取发票详情
   * @param params 参数
   */
  static async getInvoiceInfoById (type: ProjectType, id: string) {
    let pageId = type === ProjectType.Entry ? 'InputInvoice' : 'OutputInvoice'
    let filter: any[] = []
    if (id) {
      filter.push({ dataType: 6, left: 'i.id', op: 1, title: 'id', right: id})
    }
    let res = await HttpService.getPageData<InvoiceDetailInfoResult>({
      id: '列表',
      pageAddress: {pageMode:0, pageId, moduleId:"AppInterface", systemId},
      mode: 2,
      attachParams: {
        pageSize: 1,
        pageIndex: 0,
        filter: {
          type: 1,
          expressions: filter
        }
      }
    })
    filter = []
    if (id) {
      filter.push({ dataType: 6, left: (type === ProjectType.Entry ? 'id.inputInvoiceId' : 'id.outputInvoiceId'), op: 1, title: '发票id', right: id})
    }
    let details = await HttpService.getPageData<InvoiceDetailResult>({
      id: '发票款项明细',
      pageAddress: {pageMode:0,pageId,moduleId:"AppInterface",systemId},
      mode: 2,
      attachParams: {
        filter: {
          type: 1,
          expressions: filter
        }
      }
    })
    return {...res.data[0], details: details.data}
    // await sleep(1200)
    // return {"invoiceTypeName":"湖南增值税普通发票","totalAmount":"562.14","totalTaxNum":"16.86","totalTaxSum":"579.00","invoiceDataCode":"4300174320","invoiceNumber":"10283592","billingTime":"2018-05-15","checkCode":"04564180895391466033","taxpayerName":"武汉源钉云互联科技有限公司","taxpayerNumber":"91420100MA4KYDQL0U","taxpayerAddress":"","taxpayerPhone":"","taxpayerBankName":"","taxpayerBankAccount":"","salesName":"衡阳市船山宾馆有限公司","salesNum":"91430400734740323B","salesAddress":"衡阳市石鼓区蒸湘北路30号","salesPhone":"8190188","salesBankName":"中国工商银行湖南衡阳瓦子坪支行","salesBankAccount":"1905023209022303895","details":[{"name":"*住宿服务*住宿费","sum":"562.14","taxRate":"3%","tax":"16.86"}]}
  }

  /**
   * 获取当前用户对应条件下的项目列表
   * @param type ProjectType 枚举类型
   * @param pageIndex
   * @param params 参数
   * @param searchValue 搜索字符串
   */
  static async getProjectList (type: ProjectType, pageIndex: number, searchValue: string) {
    let pageId = type === ProjectType.Entry ? 'InputInvoice' : 'OutputInvoice'
    let filter: any[] = []
    // if (searchValue) {
    //   filter.push({ dataType: 6, left: 'i.id', op: 1, title: '搜索项目', right: searchValue})
    // }
    return HttpService.getPageData<ProjectInfoResult>({
      id: 'ZHZJ/项目组织',
      pageAddress: {pageMode:0, pageId, moduleId:"AppInterface", systemId},
      mode: 2,
      attachParams: {
        pageSize: 10,
        pageIndex: pageIndex,
        filter: {
          type: 1,
          expressions: filter
        }
      }
    })
  }

  /**
   * 获取当前用户对应条件下的发票列表
   * @param type 判断是否需要条件类型，all为不需要，其他为需要
   * @param projectType 当需要条件时有些，ProjectType 枚举类型
   * @param pageIndex
   * @param params 参数
   * @param searchValue 搜索字符串
   */
  static async getTicketHolderList (type: string ,projectType: ProjectType, pageIndex: number, 
    params: {projectId?: string, organizationId?: string} = {}, searchValue: string = '') {
      if (type === 'all') {
        return HttpService.getPageData<InvoiceSimpleInfoResult>({
          id: '列表',
          pageAddress: {pageMode:0, pageId: "MyInvoice", moduleId:"AppInterface", systemId},
          mode: 2,
          attachParams: {
            pageSize: 10,
            pageIndex: pageIndex,
          }
        })
      } else {
        let pageId = projectType === ProjectType.Entry ? 'InputInvoice' : 'OutputInvoice'
        let filter: any[] = []
        if (params.projectId) {
          filter.push({ dataType: 6, left: 'i.projectId', op: 1, title: '所属项目', right: params.projectId})
        }
        if (params.organizationId) {
          filter.push({ dataType: 6, left: 'i.organizationId', op: 1, title: '所属公司', right: params.organizationId})
        }
        return HttpService.getPageData<InvoiceSimpleInfoResult>({
          id: '列表',
          pageAddress: {pageMode:0, pageId, moduleId:"AppInterface", systemId},
          mode: 2,
          attachParams: {
            pageSize: 10,
            pageIndex: pageIndex,
            filter: {
              type: 1,
              expressions: filter
            }
          }
        })
    }
  }

  /**
   * 把发票提交到对应的项目
   * @param params 
   */
  static async submitInvoiceByQr (type: ProjectType, params: {qrText: string, organizationId: string, projectId: string}) {
    let id = type === ProjectType.Entry ? 'CreateInputByQr' : 'CreateOutputByQr'
    let pageId = type === ProjectType.Entry ? 'InputInvoice' : 'OutputInvoice'
    return HttpService.executeController({
      id,
      pageAddress: {pageMode:0, pageId, moduleId:"AppInterface", systemId},
      params
    })
  }

  /**
   * 把发票提交到对应的项目
   * @param params 
   */
  static async submitInvoiceByHand (type: ProjectType, params: SubmitInvoiceByHandParams) {
    let id = type === ProjectType.Entry ? 'CreateInputByHand' : 'CreateOutputByHand'
    let pageId = type === ProjectType.Entry ? 'InputInvoice' : 'OutputInvoice'
    return HttpService.executeController({
      id,
      pageAddress: {pageMode:0, pageId, moduleId:"AppInterface", systemId},
      params
    })
  }

  /**
   * 把发票更新到对应的项目
   * @param params 
   */
  static async updateInvoice (type: ProjectType, params: {id: string, projectId: string, organizationId: string}) {
    let id = type === ProjectType.Entry ? 'UpdateInput' : 'UpdateOutput'
    let pageId = type === ProjectType.Entry ? 'InputInvoice' : 'OutputInvoice'
    return HttpService.executeController({
      id,
      pageAddress: {pageMode:0, pageId, moduleId:"AppInterface", systemId},
      params
    })
  }
}



// WEBPACK FOOTER //
// ./src/AppStore/SmartMoney/SmartMoneyService.ts